import React from "react";

export default function HighlightedText({ text }) {
  const parts = text.split("**");

  return (
    <span>
      {parts.map((part, index) => (
        <React.Fragment key={index}>
          {index % 2 === 0 ? (
            part
          ) : (
            <span className="font-semibold">{part}</span>
          )}
        </React.Fragment>
      ))}
    </span>
  );
}
